import { AbstractFormElement } from "./Abstract";
import { Dropdown } from "./Dropdown";

class DropdownButton extends Dropdown {
    declare input: HTMLInputElement;

    private icon: HTMLSpanElement;

    /**
     * @inheritDoc
     */
    initElements() {
        super.initElements();
        this.icon = this.querySelector(".icon");
        if (this.dataset.staticLabel) {
            this.input.value = this.dataset.staticLabel;
        }
        return this;
    }

    /**
     * @inheritDoc
     */
    attachEvents() {
        super.attachEvents();
        this.label.removeEventListener("click", this.clickHandler);
        this.addEventListener("click", (e) => {
            if (e.target === this.icon) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.clickHandler(e);
            }
        });
        return this;
    }

    /**
     * handle change events
     * @param {option|option[]} e
     */
    handleChange(e: { label: string; value: string; idx?: number }) {
        super.handleChange(e);
        if (this.dataset.staticLabel) {
            this.input.value = this.dataset.staticLabel;
        }
    }

    get searchable() {
        return false;
    }
}

DropdownButton.prototype.shadowStyle = document.createElement("template");
DropdownButton.prototype.shadowStyle.innerHTML = `
${AbstractFormElement.prototype.shadowStyle.innerHTML}
<style>
input {
    position: relative;
    z-index: -1;
    user-select: none;
    padding-inline-end: 1em;
}
@media (max-width: 340px) {
    input {
        font-size: 14px;
    }
}
</style>
`;

customElements.define("x-dropdown-button", DropdownButton);

export default DropdownButton;
